import * as React from 'react';
import Box from '@mui/material/Box';
import {isNullOrNaN} from '../../Bs4Components/Bs4Utils';


import { compareAsc, } from "date-fns";

const relationColor = '#888888';

const ViewTimelineRelation = React.memo((props) => {
    const [strokeWidth , setStrokeWidth] = React.useState(1);
    const [[prevLeft, prevTop], setPrev] = React.useState([null, null]);
    const [[nextLeft, nextTop], setNext] = React.useState([null, null]);
    const strokeDasharray = React.useMemo(() => {
      try {
        return compareAsc(props.nextBs4Event.start, props.previousBs4Event.end) < 0 ? 5 : 'none';
      } catch (error) {}
      return 10;      
    },[props.previousBs4Event?.end, props.nextBs4Event?.start]);

    const [d, markerStart, markerEnd] = React.useMemo(() => {
      const markerStart='url(#circle)';
      const markerEnd='url(#arrow)';
      if (isNullOrNaN(nextLeft) || isNullOrNaN(nextTop)) {
        return [null, null, null];
      }
      if (isNullOrNaN(prevLeft) || isNullOrNaN(prevTop)) {
        return [`M ${nextLeft-15} ${nextTop} L ${nextLeft} ${nextTop}`, null, markerEnd];  
      }
      return [`M ${prevLeft} ${prevTop} L ${nextLeft} ${nextTop}`, markerStart, markerEnd];
    }, [prevLeft, prevTop, nextLeft, nextTop]);

    const reDraw = React.useCallback((bs4Event) => {      
      const previousRect = props.previousBs4Event?.ref?.current?.getBoundingClientRect();;
      const nextRect = props.nextBs4Event?.ref?.current?.getBoundingClientRect();
      const parentRect =  props.refParent?.current?.getBoundingClientRect();              

      if (previousRect) {
        const offsetX = previousRect.right - previousRect.left;
        const offsetY = (previousRect.bottom - previousRect.top) / 2.0;
        setPrev([previousRect.left - parentRect.left + offsetX, previousRect.top - parentRect.top + offsetY]);
      }
      if (nextRect) {
        const offsetX = 0;
        const offsetY = (nextRect.bottom - nextRect.top) / 2.0;
        setNext([nextRect.left - parentRect.left + offsetX, nextRect.top - parentRect.top + offsetY]);
      }
    }, [setPrev, setNext, props.refParent?.current, props.previousBs4Event?.ref?.current, props.nextBs4Event?.ref?.current]);

    React.useEffect(() => {      
      props.eventEmit.on(props.previousBs4Event?.key, reDraw);
      props.eventEmit.on(props.nextBs4Event?.key, reDraw)
      return () => props.eventEmit.off(reDraw);
    }, [props.eventEmit, props.previousBs4Event, props.nextBs4Event, props.updateTime, reDraw])

    React.useEffect(() => {      
      reDraw();
    }, [props.updateTime, reDraw])

    if (!d) {
      // console.log('...ViewTimelineRelation...', prevLeft, prevTop, nextLeft, nextTop)
      return null;
    } 

    const handleMouseEnter = (e) => {
      setStrokeWidth(2);
    }

    const handleMouseLeave = (e) => {
      setStrokeWidth(1);
    }

    return (
      <path 
        id={'PATH'+props.index}
        d={d} 
        stroke={relationColor}        
        strokeWidth={strokeWidth}
        fill='none'
        markerStart={markerStart}
        markerEnd={markerEnd}
        strokeDasharray={strokeDasharray}
        strokeLinecap='round'
        pointerEvents="visiblePainted"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      />
    )
  });  

  export const ViewTimelineRelationArray = React.memo((props) => {
    const ref = React.useRef(null);
    const [updateTime, setUpdateTime] = React.useState(0);

    React.useEffect(() => {
      const resizeRef = (eveny) => {
          setUpdateTime(Date.now());
      }
      
      const resizeObserver = new ResizeObserver(resizeRef);
      if (ref.current) {
        resizeObserver.observe(ref.current);
        resizeRef(null);
      }
      return () => resizeObserver.disconnect();
    }, [ref.current, setUpdateTime])  

    const markerFill = relationColor;

    return (
      <Box 
        ref={ref}
        id='ViewTimelineRelation'
        sx={{                            
          position: 'absolute',
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
          pointerEvents: 'none',
        }}
      >
        {parseFloat(ref.current?.clientWidth) > 0 && parseFloat(ref.current?.clientHeight) > 0 ?
          <svg 
            id='ViewTimelineRelation_SVG'
            xmlns="http://www.w3.org/2000/svg" 
            viewBox={`0 0 ${ref.current?.clientWidth} ${ref.current?.clientHeight}`}
            style={{        
              width: '100%',
              height: '100%',
              overflow: 'hidden',
              filter: 'drop-shadow(0 0 1px #ffffff)',
            }}            
          >	     
            <defs>            
              <marker id='circle' markerWidth='6' markerHeight='6' refX='3' refY='3'>
                <circle cx='3' cy='3' r='3' fill={markerFill} />
              </marker>
              <marker id='arrow' markerWidth='14' markerHeight='6' refX='11' refY='3' orient="auto">
                <path d="M0 0 0 6 8 3z" fill={markerFill}/>
                <circle cx='11' cy='3' r='3' fill={markerFill} />
              </marker>              
            </defs>  
            {props.bs4EventRelationArray.map((nextBs4Event, nextIndex) => {
              return nextBs4Event.id_previous_bs4Event.map((previousBs4Event, previousIndex) => {    
                const key = previousBs4Event?.key || previousBs4Event+' '+nextBs4Event.key+' '+props.timelineChangeTime?.getTime();
                if (!previousBs4Event && !nextBs4Event) return null;
                return (
                  <ViewTimelineRelation 
                    key={key} 
                    index={(nextIndex + 1)*(previousIndex)}
                    previousBs4Event={previousBs4Event} 
                    nextBs4Event={nextBs4Event} 
                    refParent={ref}
                    updateTime={updateTime}
                    timelineChangeTime={props.timelineChangeTime}
                    eventEmit={props.eventEmit}
                  />
                )
              })})} 
          </svg>
        : null}
      </Box>
    )
  });  

  export default ViewTimelineRelationArray;